module.exports = __webpack_public_path__ + "img/Screen Shot 2020-10-28 at 10.05.17 AM.ab471f57.png";